module.exports = __webpack_public_path__ + "img/icon_cooperation.e5339bdc.png";